@if (shiftView) {
  <div>
    @if (
      {
        shiftStartDetail: (shiftView.shift.activities | ganttShiftStartTime),
        shiftEndDetail: shiftView.shift.activities | ganttShiftEndTime,
      };
      as shiftTimeData
    ) {
      <div>
        @if (shiftView.shift) {
          <div>
            @if (
              {
                left:
                  (shiftTimeData.shiftStartDetail.date
                  | ganttStartingPixel
                  | async),
                right:
                  ([
                    shiftTimeData.shiftStartDetail.date,
                    shiftTimeData.shiftEndDetail.date,
                  ]
                  | ganttEndingPixel
                  | async),
              };
              as data
            ) {
              <div
                class="shift shift-dotted"
                [class.row-hovered]="isHovered && !isActivitiesView"
                [class.filtered]="shiftView.shift.isHighlighted"
                [style.left.px]="data.left"
                [style.right.px]="data.right"
              >
                <wilson-shift-validation-tooltip-wrapper
                  [showShiftValidation]="false"
                  [plannedShiftStartDateTime]="plannedShiftStartDateTime"
                  [plannedShiftEndDateTime]="plannedShiftEndDateTime"
                  [accurateShiftStartDateTime]="
                    shiftTimeData.shiftStartDetail.date
                  "
                  [accurateShiftEndDateTime]="shiftTimeData.shiftEndDetail.date"
                  [shiftStartTimeDifference]="
                    shiftTimeData.shiftStartDetail.timeDifference
                  "
                  [shiftEndTimeDifference]="
                    shiftTimeData.shiftEndDetail.timeDifference
                  "
                  [shiftStartTimeType]="shiftTimeData.shiftStartDetail.type"
                  [shiftEndTimeType]="shiftTimeData.shiftEndDetail.type"
                  [plannedStartLocation]="
                    shiftTimeData.shiftStartDetail.location
                  "
                  [plannedEndLocation]="shiftTimeData.shiftEndDetail.location"
                  [reportedStartLocation]="null"
                  [reportedEndLocation]="null"
                >
                  @if (
                    {
                      calculatedShiftWidth:
                        data | timeDifferenceWidthPx | async,
                    };
                    as shiftData
                  ) {
                    @if (
                      shiftData.calculatedShiftWidth &&
                      (shiftData.calculatedShiftWidth > FIRST_BREAKPOINT ||
                        shiftData.calculatedShiftWidth < SECOND_BREAKPOINT)
                    ) {
                      <div class="shift-details assignment-name">
                        <div class="d-flex justify-content-between">
                          <div
                            [ngClass]="
                              shiftData.calculatedShiftWidth > MIN_WIDTH_PX
                                ? 'shift-name'
                                : 'no-text'
                            "
                          >
                            {{ shiftView.shift.name }}
                          </div>
                        </div>
                        @if (!isActivitiesView) {
                          <div
                            class="d-flex flex-grow-1 justify-content-between"
                          >
                            <div>
                              <div
                                [ngClass]="
                                  shiftData.calculatedShiftWidth > MIN_WIDTH_PX
                                    ? 'shift-code-start'
                                    : 'no-text'
                                "
                              >
                                {{
                                  shiftTimeData.shiftStartDetail.location
                                    ?.locationCode
                                }}
                              </div>
                              <div
                                [ngClass]="
                                  shiftData.calculatedShiftWidth > MIN_WIDTH_PX
                                    ? 'time-range-start'
                                    : 'no-text'
                                "
                              >
                                {{
                                  shiftTimeData.shiftStartDetail.date
                                    | date: 'HH:mm'
                                }}
                              </div>
                            </div>
                            <div>
                              <div
                                [ngClass]="
                                  shiftData.calculatedShiftWidth > MIN_WIDTH_PX
                                    ? 'shift-code-end'
                                    : 'no-text'
                                "
                              >
                                {{
                                  shiftTimeData.shiftEndDetail.location
                                    ?.locationCode
                                }}
                              </div>
                              <div
                                [ngClass]="
                                  shiftData.calculatedShiftWidth > MIN_WIDTH_PX
                                    ? 'time-range-end'
                                    : 'no-text'
                                "
                              >
                                {{
                                  shiftTimeData.shiftEndDetail.date
                                    | date: 'HH:mm '
                                }}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      @if (!isActivitiesView) {
                        <div class="d-flex justify-content-end">
                          <div class="medium-shift-code-start">
                            {{
                              shiftTimeData.shiftStartDetail.location
                                ?.locationCode
                            }}
                          </div>
                        </div>
                        <div class="medium-shift-code-end">
                          {{
                            shiftTimeData.shiftEndDetail.location?.locationCode
                          }}
                        </div>
                      }
                    }
                  }
                </wilson-shift-validation-tooltip-wrapper>
              </div>
            }
            @if (isActivitiesView) {
              @for (
                innerRowActivities of shiftView.activitiesInRowLevels;
                track innerRowActivities
              ) {
                <div
                  [style.height.px]="
                    shiftView.activitiesInRowLevels.length > 1
                      ? defaultShiftHeight
                      : 'auto'
                  "
                >
                  <wilson-activities-row
                    [activities]="innerRowActivities"
                    [dottedBorder]="true"
                    [isHovered]="isHovered"
                  ></wilson-activities-row>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
